/**
 * Detects Datalogic Enterprise Browser by checking injected SDK in global scope
 *
 * @returns boolean
 */
export const detectDatalogicBrowser = (): boolean => {
  try {
    return !!_DLBarcodeMgr;
  } catch (e) {
    return false;
  }
};
